function datacleansing () {
	const elId = '#app-datacleansing';
	const elClass = '.js-vue-datacleansing';

	if ($(elId).length == 0 || $(elClass).length == 0) {
		return;
	}

	const app = new Vue({
		el: elId,
		data: {
			configs: null,
			selectedConfig: null,
			restGetRow: null,
			restPostHandler: null,
			restPutContact: null,
			result: null,
			error: null
		},
		created: function () {
			const self = this;
			GET('/baas/nominow_deduplication/configs').then(xhr => {
				const response = JSON.parse(xhr.responseText);
				self.configs = response;
				self.setConfig(self.configs[0]);
			});
		},
		mounted: function () {
			$(elClass).removeClass('is-mounting');
		},
		updated: function () {
			window.initFixed();
		},
		computed: {
			vueMatchHeightsSettings: function () {
				const arr = [];
				for (let i = 0; i < this.result.CheckResult.length; i++) {
					arr.push(`.vue-equal-height-row-${i}`);
				}
				const settings = { el: arr };
				return settings;
			}
		},
		methods: {
			updateField: function (field, type) {
				if (type == 'original') {
					this.result.Merged[field.FieldName] = this.result.Original[field.FieldName];
					field.MergedTranslation = field.OriginalTranslation;
				}
				if (type == 'duplicate') {
					this.result.Merged[field.FieldName] = this.result.Duplicate[field.FieldName];
					field.MergedTranslation = field.DuplicateTranslation;
				}
			},
			setConfig: function (config) {
				const self = this;
				self.result = null;
				self.error = null;
				toggleLoader(true);
				self.selectedConfig = config;

				for (let i = 0; i < config.Deduplicate.StoredProcedures.length; i++) {
					if (config.Deduplicate.StoredProcedures[i].SpType == '1') {
						self.restGetRow = config.Deduplicate.StoredProcedures[i].SpName;
					} else if (config.Deduplicate.StoredProcedures[i].SpType == '2') {
						self.restPostHandler = config.Deduplicate.StoredProcedures[i].SpName;
					} else if (config.Deduplicate.StoredProcedures[i].SpType == '3') {
						self.restPutContact = config.Deduplicate.StoredProcedures[i].SpName;
					} else {
						window.initToast('error', `invalid rest type ${config.Deduplicate.StoredProcedures[i].SpType}`);
					}
				}

				GET(`/baas/${self.restGetRow}?configId=${config.DeduplicateConfigId}`)
					.then(xhr => {
						toggleLoader(false);
						self.result = JSON.parse(xhr.responseText);
						$(elClass).removeClass('is-creating');
					})
					.catch(xhr => {
						toggleLoader(false);
						self.error = xhr.responseText != '' ? xhr.responseText : timeOutResponseText;
						$(elClass).removeClass('is-creating');
					});
			},
			postpone: function (event) {
				if (isLoading(event.target)) {
					return;
				}
				const self = this;
				toggleLoader(true);
				POST(`/baas/${this.restPostHandler}`, {
					ContactDuplicateGuid: this.result.ContactDuplicateGuid,
					DedupeProcess: 'POSTPONE'
				})
					.then(() => {
						self.error = null;
						self.setConfig(self.selectedConfig);
						toggleLoader(false);
					})
					.catch(xhr => {
						self.error = xhr.responseText != '' ? xhr.responseText : timeOutResponseText;
						toggleLoader(false);
					});
			},
			seperate: function (event) {
				if (isLoading(event.target)) {
					return;
				}
				const self = this;
				toggleLoader(true);
				POST(`/baas/${this.restPostHandler}`, {
					ContactDuplicateGuid: this.result.ContactDuplicateGuid,
					DedupeProcess: 'NOTSAME'
				})
					.then(() => {
						self.error = null;
						self.setConfig(self.selectedConfig);
						toggleLoader(false);
					})
					.catch(xhr => {
						self.error = xhr.responseText != '' ? xhr.responseText : timeOutResponseText;
						toggleLoader(false);
					});
			},
			merge: function (event) {
				if (isLoading(event.target)) {
					return;
				}
				const self = this;
				toggleLoader(true);
				PUT(`/baas/${this.restPutContact}`, this.result.Merged)
					.then(xhr => {
						self.error = null;
						if (xhr.status == 200) {
							POST(`/baas/nominow_deduplication/${self.restPostHandler}`, {
								ContactDuplicateGuid: self.result.ContactDuplicateGuid,
								DedupeProcess: 'DEDUPE'
							})
								.then(xhr2 => {
									self.error = null;
									self.setConfig(self.selectedConfig);
									toggleLoader(false);
								})
								.catch(xhr2 => {
									self.error = xhr2.responseText != '' ? xhr2.responseText : timeOutResponseText;
									toggleLoader(false);
								});
						}
					})
					.catch(xhr => {
						self.error = xhr.responseText != '' ? xhr.responseText : timeOutResponseText;
						toggleLoader(false);
					});
			}
		}
	});
	/* App is added as window.activeRootComponent so that it can be used by helpers, such as the keyup helper. */
	window.activeRootComponent = app;
}
datacleansing();
